function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Sanitization");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sanitization"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,9.33333335 L12.1518457,10.9546927 C14.1259065,14.3172776 15.1666667,18.1458291 15.1666667,22.0450462 L15.1666667,26.8333334 C15.1666667,27.4776656 14.6443322,28 14,28 L2.33333333,28 C1.68900113,28 1.16666667,27.4776656 1.16666667,26.8333334 L1.16666667,22.0450462 C1.16666667,18.1458291 2.20742679,14.3172776 4.18148764,10.9546927 L5.13333333,9.33333335 L11.2,9.33333335 Z M24.2097257,5.57056954 C25.015141,5.57056954 25.6680591,6.22348762 25.6680591,7.02890288 C25.6680591,7.83431814 25.015141,8.48723621 24.2097257,8.48723621 C23.4043105,8.48723621 22.7513924,7.83431814 22.7513924,7.02890288 C22.7513924,6.22348762 23.4043105,5.57056954 24.2097257,5.57056954 Z M14,2.3333334 L14,3.50000001 L16.3333333,3.50000001 L16.3333333,5.83333334 L14,5.83333334 L14,7.00000006 L2.33333333,7.00000006 C2.33333333,4.42267123 4.42267117,2.3333334 7,2.3333334 L14,2.3333334 Z M20.125,3.20833333 C20.9304153,3.20833333 21.5833333,3.86125141 21.5833333,4.66666667 C21.5833333,5.47208193 20.9304153,6.125 20.125,6.125 C19.3195847,6.125 18.6666667,5.47208193 18.6666667,4.66666667 C18.6666667,3.86125141 19.3195847,3.20833333 20.125,3.20833333 Z M24.2097257,0.903902878 C25.015141,0.903902878 25.6680591,1.55682095 25.6680591,2.36223621 C25.6680591,3.16765147 25.015141,3.82056954 24.2097257,3.82056954 C23.4043105,3.82056954 22.7513924,3.16765147 22.7513924,2.36223621 C22.7513924,1.55682095 23.4043105,0.903902878 24.2097257,0.903902878 Z",
  id: "Combined-Shape",
  fill: "#3366CC"
})));

var SvgSanitization = function SvgSanitization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSanitization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sanitization.23c8167d.svg";
export { ForwardRef as ReactComponent };